export default __webpack_public_path__ + "static/media/icon_diamond_white.e34e4f66.svg";